// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bw-text: #13231D;
  --bw-text-secondary: rgba(19, 35, 29, 0.68);
  --bw-text-tertiary: rgba(19, 35, 29, 0.46);
  --bw-primary: #82B194;
  --base-container: 1280px;
  --gutter-desktop: 40px;
  --gutter-tablet: 28px;
  --gutter-mobile: 20px;
  --border-soft: rgba(19, 35, 29, 0.08);
  --border-mid: rgba(19, 35, 29, 0.22);
  --radius-card: 32px;
  --radius-card-sm: 24px;
  --radius-button: 20px;
  --radius-button-header: 18px;
  --shadow-soft: 0 18px 48px rgba(18, 34, 29, 0.04);
}

.DashboardPatient_dashboard__w-By0 {
  width: 100%;
  color: #13231D;
  font-family: "Sora", sans-serif;
  background-color: transparent;
}
@media (max-width: 768px) {
  .DashboardPatient_dashboard__w-By0 {
    padding: 10px 0;
  }
}
.DashboardPatient_dashboard__header__-wP\\+9 {
  margin-bottom: 24px;
  padding: 0 4px;
}
.DashboardPatient_dashboard__title__BRFVz {
  font-size: 28px;
  font-weight: 800;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #13231D;
  letter-spacing: -0.02em;
}
.DashboardPatient_dashboard__subtitle__wQoO- {
  color: rgba(19, 35, 29, 0.68);
  margin: 8px 0 0;
  font-size: 16px;
  font-weight: 500;
}
@media (max-width: 768px) {
  .DashboardPatient_dashboard__subtitle__wQoO- {
    font-size: 14px;
  }
}
.DashboardPatient_dashboard__mainGrid__r5DF8 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-top: 24px;
}
@media (min-width: 1024px) {
  .DashboardPatient_dashboard__mainGrid__r5DF8 {
    grid-template-columns: 1.8fr 1fr;
  }
}
.DashboardPatient_dashboard__sidebar__ysPdw {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.DashboardPatient_widget-card__YPY\\+r {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 24px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.03);
  display: flex;
  flex-direction: column;
  transition: transform 0.2s ease;
}
@media (max-width: 768px) {
  .DashboardPatient_widget-card__YPY\\+r {
    padding: 24px 20px;
  }
}
.DashboardPatient_widget-card__YPY\\+r:hover {
  transform: translateY(-2px);
}
.DashboardPatient_widget-card__header__r3WXv {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
}
.DashboardPatient_widget-card__icon-box__xUu9d {
  width: 48px;
  height: 48px;
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 14px;
  display: grid;
  place-items: center;
  color: rgba(19, 35, 29, 0.68);
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .DashboardPatient_widget-card__icon-box__xUu9d {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }
  .DashboardPatient_widget-card__icon-box__xUu9d svg {
    font-size: 20px !important;
  }
}
.DashboardPatient_widget-card__eyebrow__jn5D3 {
  display: block;
  font-size: 10px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #82B194;
  margin-bottom: 2px;
}
.DashboardPatient_widget-card__title__oxTI2 {
  margin: 0;
  font-size: 16px;
  font-weight: 800;
  color: #13231D;
  letter-spacing: -0.01em;
}

.DashboardPatient_agenda-list__m9KOq {
  display: flex;
  flex-direction: column;
}
.DashboardPatient_agenda-list--empty__K5KKZ {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  background: rgba(130, 177, 148, 0.03);
  border-radius: 24px;
  border: 2px dashed rgba(130, 177, 148, 0.15);
  text-align: center;
  margin: 10px 0;
  transition: all 0.3s ease;
}
.DashboardPatient_agenda-list--empty__K5KKZ:hover {
  background: rgba(130, 177, 148, 0.05);
  border-color: rgba(130, 177, 148, 0.25);
}
.DashboardPatient_agenda-list--empty__icon-box__w77be {
  width: 64px;
  height: 64px;
  background: #fff;
  border-radius: 50%;
  display: grid;
  place-items: center;
  color: rgba(130, 177, 148, 0.4);
  margin-bottom: 20px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}
.DashboardPatient_agenda-list--empty__title__B8r87 {
  font-size: 18px;
  font-weight: 800;
  color: #13231D;
  margin: 0 0 8px;
  letter-spacing: -0.02em;
}
.DashboardPatient_agenda-list--empty__text__zY0\\+0 {
  font-size: 14px;
  color: rgba(19, 35, 29, 0.68);
  margin: 0;
  max-width: 280px;
  line-height: 1.5;
}

.DashboardPatient_appointment-item__NwXdb {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 16px 20px;
  background: #F7F5F1;
  border-radius: 18px;
  margin-bottom: 12px;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}
@media (max-width: 600px) {
  .DashboardPatient_appointment-item__NwXdb {
    gap: 12px;
    padding: 14px 16px;
  }
}
.DashboardPatient_appointment-item__NwXdb:hover {
  background: #fff;
  border-color: rgba(130, 177, 148, 0.3);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.04);
}
.DashboardPatient_appointment-item__time-box__kk4aR {
  text-align: center;
  min-width: 70px;
  padding-right: 16px;
  border-right: 1px solid rgba(16, 25, 21, 0.06);
}
@media (max-width: 480px) {
  .DashboardPatient_appointment-item__time-box__kk4aR {
    min-width: 60px;
    padding-right: 10px;
  }
}
.DashboardPatient_appointment-item__date__iV1CC {
  font-size: 11px;
  font-weight: 800;
  color: #82B194;
  display: block;
  text-transform: uppercase;
}
@media (max-width: 480px) {
  .DashboardPatient_appointment-item__date__iV1CC {
    font-size: 9px;
  }
}
.DashboardPatient_appointment-item__hour__jvA-3 {
  font-size: 15px;
  font-weight: 800;
  color: #13231D;
}
@media (max-width: 480px) {
  .DashboardPatient_appointment-item__hour__jvA-3 {
    font-size: 13px;
  }
}
.DashboardPatient_appointment-item__info__ER1\\+E {
  flex: 1 1;
}
.DashboardPatient_appointment-item__professional__gQ61-, .DashboardPatient_appointment-item__patient__BBjaZ {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #13231D;
}
@media (max-width: 480px) {
  .DashboardPatient_appointment-item__professional__gQ61-, .DashboardPatient_appointment-item__patient__BBjaZ {
    font-size: 14px;
  }
}
.DashboardPatient_appointment-item__reason__p02bE {
  margin: 2px 0 0;
  font-size: 13px;
  color: rgba(19, 35, 29, 0.68);
  font-weight: 500;
}
@media (max-width: 480px) {
  .DashboardPatient_appointment-item__reason__p02bE {
    font-size: 12px;
  }
}
.DashboardPatient_appointment-item__link__lqEvU {
  width: 36px;
  height: 36px;
  background: #fff;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: #82B194;
  transition: all 0.2s;
}
.DashboardPatient_appointment-item__link__lqEvU:hover {
  background: #82B194;
  color: #fff;
  transform: scale(1.05);
}

.DashboardPatient_kpiCard__3Ao4f {
  background: #F7F5F1;
  border: 1px solid rgba(16, 25, 21, 0.08);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 3px 7px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 1rem;
  border-left: 5px solid transparent;
  transition: transform 0.2s;
}
@media (max-width: 480px) {
  .DashboardPatient_kpiCard__3Ao4f {
    padding: 1rem;
    gap: 0.75rem;
  }
}
.DashboardPatient_kpiCard__3Ao4f:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.22);
}
.DashboardPatient_kpiCard--green__7etih {
  border-left-color: #2ecc71;
  color: rgb(36.616, 162.384, 89.948);
}
.DashboardPatient_kpiCard--grey__xUbMi {
  border-left-color: #95a5a6;
  color: rgb(121.2769230769, 141.4615384615, 142.7230769231);
}
.DashboardPatient_kpiCard__iconContainer__PmqQA {
  background-color: rgba(0, 0, 0, 0.03);
  padding: 10px;
  border-radius: 50%;
  display: flex;
}
.DashboardPatient_kpiCard__content__kOfKW {
  display: flex;
  flex-direction: column;
}
.DashboardPatient_kpiCard__label__ITu-y {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(19, 35, 29, 0.68);
  margin-bottom: 4px;
}
.DashboardPatient_kpiCard__value__TNV76 {
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0;
  color: #13231D;
}
.DashboardPatient_kpiCard__subtext__nG5eN {
  font-size: 0.85rem;
  color: rgba(19, 35, 29, 0.68);
  margin-top: 4px;
}
.DashboardPatient_kpiCard__trend__--0Nm {
  font-size: 0.85rem;
  margin-top: 4px;
  font-weight: 600;
}
.DashboardPatient_kpiCard__trend--positive__lp83l {
  color: #2ecc71;
}

.DashboardPatient_widget__jA0i0 {
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 3px 7px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}
.DashboardPatient_widget__header__pWXaH {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid rgba(91.6666666667, 166.3333333333, 138.3333333333, 0.68);
  padding-bottom: 1rem;
}
.DashboardPatient_widget__icon__H4Qem {
  color: rgba(19, 35, 29, 0.68);
}
.DashboardPatient_widget__title__jqFB6 {
  font-size: 1rem;
  font-weight: 700;
  margin: 0;
  color: #13231D;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.DashboardPatient_agendaWidget__qYQrq {
  height: 100%;
}
.DashboardPatient_agendaWidget__list__MGNro {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.DashboardPatient_appointmentRow__gdUZB {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  flex-wrap: wrap;
  gap: 1rem;
}
.DashboardPatient_appointmentRow__time__0LF6j {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 80px;
  padding-right: 1rem;
  border-right: 1px solid #e0e0e0;
  margin-right: 0.5rem;
}
.DashboardPatient_appointmentRow__date__SAIzq {
  font-size: 0.75rem;
  font-weight: 700;
  color: rgba(19, 35, 29, 0.68);
  text-transform: uppercase;
  margin-bottom: 2px;
}
.DashboardPatient_appointmentRow__hour__0B0bD {
  font-weight: 800;
  color: #13231D;
  font-size: 1rem;
}
.DashboardPatient_appointmentRow__info__plDKm {
  flex: 1 1;
  display: flex;
  flex-direction: column;
}
.DashboardPatient_appointmentRow__name__wKNc9 {
  font-weight: 600;
  font-size: 1rem;
}
.DashboardPatient_appointmentRow__type__dpEqK {
  font-size: 0.85rem;
  color: rgba(19, 35, 29, 0.68);
}
.DashboardPatient_appointmentRow__action__V7e7x {
  display: flex;
}

.DashboardPatient_btn__QfZ38 {
  border: none;
  border-radius: 6px;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.2s;
}
.DashboardPatient_btn--video__ptvi7 {
  background-color: #82B194;
  color: #ffffff;
  box-shadow: 0 2px 4px rgba(130, 177, 148, 0.3);
}
.DashboardPatient_btn--video__ptvi7:hover {
  background-color: rgb(98.5960591133, 157.4039408867, 121.118226601);
}
.DashboardPatient_btn--outline__XS6ob {
  background-color: transparent;
  border: 1px solid rgba(19, 35, 29, 0.68);
  color: rgba(19, 35, 29, 0.68);
}
.DashboardPatient_btn--outline__XS6ob:hover {
  border-color: #13231D;
  color: #13231D;
}

.DashboardPatient_occupancyWidget__content__1MZGE {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
}
.DashboardPatient_occupancyWidget__legend__NvmMD {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
}
.DashboardPatient_occupancyWidget__legend__NvmMD li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: rgba(19, 35, 29, 0.68);
}

.DashboardPatient_donutChart__tS9HH {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  background: conic-gradient(#2ecc71 0% 75%, rgba(91.6666666667, 166.3333333333, 138.3333333333, 0.68) 75% 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.DashboardPatient_donutChart__center__zPnwm {
  width: 100px;
  height: 100px;
  background: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 1.5rem;
  color: #13231D;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
}

.DashboardPatient_dot__HulH3 {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.DashboardPatient_dot--occupied__9f10r {
  background-color: #2ecc71;
}
.DashboardPatient_dot--free__jStKk {
  background-color: rgba(91.6666666667, 166.3333333333, 138.3333333333, 0.68);
}

.DashboardPatient_walletWidget__YpJiy {
  background: linear-gradient(135deg, #13231D 0%, #1a252f 100%);
  color: #ffffff;
}
.DashboardPatient_walletWidget__YpJiy .DashboardPatient_widget__title__jqFB6,
.DashboardPatient_walletWidget__YpJiy .DashboardPatient_widget__icon__H4Qem {
  color: #ffffff;
}
.DashboardPatient_walletWidget__YpJiy .DashboardPatient_widget__header__pWXaH {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}
.DashboardPatient_walletWidget__content__WiX2D {
  display: flex;
  flex-direction: column;
}
.DashboardPatient_walletWidget__label__ccSrR {
  font-size: 0.9rem;
  opacity: 0.7;
  margin-bottom: 0.5rem;
}
.DashboardPatient_walletWidget__balance__P\\+Y4- {
  font-size: 2rem;
  margin: 0 0 1.5rem 0;
  font-weight: 700;
}
.DashboardPatient_walletWidget__link__nXZS8 {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: #ffffff;
  padding: 0.8rem;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background 0.2s;
}
.DashboardPatient_walletWidget__link__nXZS8:hover {
  background: rgba(255, 255, 255, 0.2);
}

.DashboardPatient_patient-to-pro-banner__LImKz {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 24px;
}

.DashboardPatient_patient-to-pro-btn__Nf1Ba {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background-color: #f1f5f9;
  color: #475569;
  padding: 8px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid #e2e8f0;
}
.DashboardPatient_patient-to-pro-btn__Nf1Ba:hover {
  background-color: #e2e8f0;
  color: #0f172a;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/components/DashboardPatient/DashboardPatient.module.scss"],"names":[],"mappings":"AAyIA;EACI,kBAAA;EACA,2CAAA;EACA,0CAAA;EACA,qBAAA;EAEA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,qBAAA;EAGA,qCAAA;EACA,oCAAA;EAEA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,4BAAA;EAEA,iDAAA;AC7IJ;;AAOA;EACE,WAAA;EACA,cDDqB;ECErB,+BAAA;EACA,6BAAA;AAJF;AAME;EANF;IAOI,eAAA;EAHF;AACF;AAKE;EACE,mBAAA;EACA,cAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cDrBmB;ECsBnB,uBAAA;AAJJ;AAeE;EACE,6BDhCmB;ECiCnB,eAAA;EACA,eAAA;EACA,gBAAA;AAbJ;AAcI;EALF;IAMI,eAAA;EAXJ;AACF;AAcE;EACE,aAAA;EACA,0BAAA;EACA,SAAA;EACA,gBAAA;AAZJ;AAcI;EANF;IAOI,gCAAA;EAXJ;AACF;AAcE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAZJ;;AAgBA;EACE,mBDnEqB;ECoErB,wCAAA;EACA,mBA7Ea;EA8Eb,aAAA;EACA,2CDxBY;ECyBZ,aAAA;EACA,sBAAA;EACA,+BAAA;AAbF;AAeE;EAVF;IAWI,kBAAA;EAZF;AACF;AAcE;EACE,2BAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,WAAA;EACA,YAAA;EACA,mBD9FmB;EC+FnB,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,6BD5FmB;EC6FnB,cAAA;AAdJ;AAgBI;EAXF;IAYI,WAAA;IACA,YAAA;IACA,mBAAA;EAbJ;EAcI;IAAM,0BAAA;EAXV;AACF;AAcE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cD5HmB;EC6HnB,kBAAA;AAZJ;AAeE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDvHmB;ECwHnB,uBAAA;AAbJ;;AAiBA;EACE,aAAA;EACA,sBAAA;AAdF;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,4CAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;AAdJ;AAgBI;EACE,qCAAA;EACA,uCAAA;AAdN;AAiBI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2CAAA;AAfN;AAkBI;EACE,eAAA;EACA,gBAAA;EACA,cDjKiB;ECkKjB,eAAA;EACA,uBAAA;AAhBN;AAmBI;EACE,eAAA;EACA,6BDtKiB;ECuKjB,SAAA;EACA,gBAAA;EACA,gBAAA;AAjBN;;AAsBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBD1LqB;EC2LrB,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;AAnBF;AAqBE;EAXF;IAYI,SAAA;IACA,kBAAA;EAlBF;AACF;AAoBE;EACE,gBAAA;EACA,sCAAA;EACA,0CAAA;AAlBJ;AAqBE;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,8CAAA;AAnBJ;AAqBI;EANF;IAOI,eAAA;IACA,mBAAA;EAlBJ;AACF;AAqBE;EACE,eAAA;EACA,gBAAA;EACA,cDlOmB;ECmOnB,cAAA;EACA,yBAAA;AAnBJ;AAoBI;EANF;IAM8B,cAAA;EAhB9B;AACF;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,cD7NmB;AC8MvB;AAgBI;EAJF;IAI8B,eAAA;EAZ9B;AACF;AAcE;EAAU,SAAA;AAXZ;AAYE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cDtOmB;AC4NvB;AAWI;EALF;IAK8B,eAAA;EAP9B;AACF;AAQE;EACE,eAAA;EACA,eAAA;EACA,6BD1OmB;EC2OnB,gBAAA;AANJ;AAOI;EALF;IAK8B,eAAA;EAH9B;AACF;AAKE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,wCAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,cDtQmB;ECuQnB,oBAAA;AAHJ;AAKI;EACI,mBD1Qe;EC2Qf,WAAA;EACA,sBAAA;AAHR;;AAQA;EACE,mBD1QqB;EC2QrB,wCAAA;EACA,mBA5Qc;EA6Qd,eAAA;EACA,4CA7QU;EA8QV,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kCAAA;EACA,0BAAA;AALF;AAOE;EAZF;IAaI,aAAA;IACA,YAAA;EAJF;AACF;AAME;EACE,2BAAA;EACA,0CA1RQ;AAsRZ;AAOE;EACE,0BAnSW;EAoSX,mCAAA;AALJ;AAOE;EACE,0BArSU;EAsSV,0DAAA;AALJ;AAQE;EACE,qCAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;AANJ;AASE;EACE,aAAA;EACA,sBAAA;AAPJ;AAUE;EACE,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,6BDjTmB;ECkTnB,kBAAA;AARJ;AAWE;EACE,iBAAA;EACA,gBAAA;EACA,SAAA;EACA,cD3TmB;ACkTvB;AAYE;EACE,kBAAA;EACA,6BD9TmB;EC+TnB,eAAA;AAVJ;AAaE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AAXJ;AAaI;EACE,cAlVS;AAuUf;;AAgBA;EACE,mBA3VM;EA4VN,mBAtVc;EAuVd,eAAA;EACA,4CAvVU;EAwVV,aAAA;EACA,sBAAA;AAbF;AAeE;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,kFAAA;EACA,oBAAA;AAbJ;AAgBE;EACE,6BD/VmB;ACiVvB;AAiBE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cDxWmB;ECyWnB,yBAAA;EACA,qBAAA;AAfJ;;AAmBA;EACE,YAAA;AAhBF;AAkBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAhBJ;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;AAjBF;AAmBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;EACA,+BAAA;EACA,oBAAA;AAjBJ;AAoBE;EACE,kBAAA;EACA,gBAAA;EACA,6BD9YmB;EC+YnB,yBAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,gBAAA;EACA,cDvZmB;ECwZnB,eAAA;AAnBJ;AAsBE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;AApBJ;AAuBE;EACE,gBAAA;EACA,eAAA;AArBJ;AAwBE;EACE,kBAAA;EACA,6BDtamB;ACgZvB;AAyBE;EACE,aAAA;AAvBJ;;AA2BA;EACE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,oBAAA;AAxBF;AA0BE;EACE,yBD1cmB;EC2cnB,cAzcI;EA0cJ,8CAAA;AAxBJ;AA0BI;EACE,mEAAA;AAxBN;AA4BE;EACE,6BAAA;EACA,wCAAA;EACA,6BDvcmB;AC6avB;AA4BI;EACE,qBD5ciB;EC6cjB,cD7ciB;ACmbvB;;AAgCE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AA7BJ;AAgCE;EACE,gBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AA9BJ;AAgCI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BDpeiB;ACscvB;;AAmCA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,8GAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAhCF;AAkCE;EACE,YAAA;EACA,aAAA;EACA,mBAngBI;EAogBJ,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cD/fmB;ECggBnB,8CAAA;AAhCJ;;AAoCA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;AAjCF;AAmCE;EACE,yBAphBW;AAmff;AAmCE;EACE,2EAAA;AAjCJ;;AAqCA;EACE,6DAAA;EACA,cAhiBM;AA8fR;AAoCE;;EAEE,cApiBI;AAkgBR;AAqCE;EACE,iDAAA;AAnCJ;AAsCE;EACE,aAAA;EACA,sBAAA;AApCJ;AAuCE;EACE,iBAAA;EACA,YAAA;EACA,qBAAA;AArCJ;AAwCE;EACE,eAAA;EACA,oBAAA;EACA,gBAAA;AAtCJ;AAyCE;EACE,oCAAA;EACA,YAAA;EACA,cA/jBI;EAgkBJ,eAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,2BAAA;AAvCJ;AAyCI;EACE,oCAAA;AAvCN;;AA4CA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AAzCJ;;AA4CA;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;EACA,yBAAA;AAzCJ;AA2CI;EACI,yBAAA;EACA,cAAA;AAzCR","sourcesContent":["\n// =============================================================================\n// BODHIWELL DESIGN TOKENS\n// =============================================================================\n\n// FONTS\n$font-main: \"Sora\", system-ui, -apple-system, \"Segoe UI\", Roboto, Arial, sans-serif;\n$font-accent: $font-main;\n\n\n// Brand Colors\n$color-primary:        #82B194; // CTA principal, estados activos y acentos del sistema.\n$color-primary-hover:  #739F84;\n$color-primary-active: #678F77;\n$color-gold:           #D6A640;  // Acento complementario para journeys, hitos y estados destacados dentro del dashboard.\n$color-gold-soft:      rgba(214, 166, 64, 0.10);\n\n// Backgrounds & Surfaces\n$color-bg:             #EFF0EC; // Fondo general del sistema y de ejemplos.\n$color-surface:        #F7F5F1; // Superficie oficial para cards, modales y contenedores principales del sistema.\n$color-surface-soft:   #F8F6F2; // Variante suave para interiores, previews, campos y superficies secundarias.\n$color-border:         rgba(16, 25, 21, 0.08); \n\n// Text Colors\n$text-main:            #13231D; // Titulares, labels y acciones principales. Color principal para títulos, cuerpo y acciones prioritarias. \n$text-muted:           #5F726B;\n$text-secondary:       rgba(19,35,29,.68); // Textos de apoyo, descripciones, subtítulos y metadata.\n$text-tertiary:        rgba(19,35,29,.46);  // Footer, placeholders y elementos de menor jerarquía visual.\n\n// Status Colors\n$color-error:          #C95C5C; // Mensajes de validación, borde error y helper error.\n\n\n// Font Sizes\n$font-size-h1:      64px; \n$font-size-h2:      48px; \n$font-size-h3:      24px; \n$font-size-title-mobile: 32px; \n$font-size-body:    16px; \n$font-size-small:   14px; \n$font-size-caption: 13px; \n\n$font-size-section-titles: $font-size-h2; \n$font-size-section-subtitles: $font-size-h3;\n$font-size-section-descripcion: $font-size-body;\n\n$radius-nav:    12px;  // Navegación del manual, tabs suaves y acciones de baja jerarquía.\n$radius-sm:     14px;  // Botones de soporte, badges rectangulares y accesos rápidos.\n$radius-md:     16px;  // Botones principales, inputs, CTA sobre imagen y controles activos.\n$radius-lg:     18px;  // Cards internas, previews, notas y paneles secundarios.\n$radius-xl:     24px;  // Cards principales del manual, modales y contenedores base del sistema.\n$radius-pill:   999px; // Tags de dimensión, chips y elementos totalmente redondeados.\n\n$border-radius: $radius-md;\n$btn-radius:    $radius-pill;\n\n// --- 5. SPACING SCALE ---\n$space-4:  4px;\n$space-8:  8px;\n$space-12: 12px;\n$space-16: 16px;\n$space-24: 24px;\n$space-32: 32px;\n$space-48: 48px;\n\n// --- 6. SHADOWS ---\n$shadow-card: 0 10px 30px rgba(0, 0, 0, 0.03); \n\n$header-height:       64px;\n$sidebar-width-open:  240px;\n$sidebar-width-closed: 80px;\n$submenu-panel-width: 280px;\n\n$transition-speed:    0.3s;\n\n$breakpoint-sm:       576px;\n$breakpoint-md:       768px;\n$breakpoint-lg:       992px;\n$breakpoint-desktop:  1024px;\n\n$base-container:1280px;\n$gutter-desktop:40px;\n$gutter-tablet:28px;\n$gutter-mobile:20px;\n\n$border-soft:rgba(19,35,29,.08);\n$border-mid:rgba(19,35,29,.22);\n\n$radius-card:32px;\n$radius-card-sm:24px;\n$radius-button:20px;\n$radius-button-header:18px;\n\n$shadow-soft:0 18px 48px rgba(18,34,29,.04);\n\n$sidebar-bg:           $color-surface;\n$sidebar-submenu-bg:   #ffffff;\n$sidebar-text-color:   $text-main;\n$sidebar-active-bg:    rgba($color-primary, 0.1);\n$sidebar-active-text:  $color-primary;\n\n\n// Mixins para Tipografía\n@mixin h1 {\n    font-size: 64px;\n    line-height: 1.0;\n    font-weight: 700;\n    letter-spacing: -0.045em;\n}\n\n@mixin h2 {\n    font-size: 48px;\n    line-height: 1.04;\n    font-weight: 800;\n    letter-spacing: -0.035em;\n}\n\n@mixin h3 {\n    font-size: 24px;\n    line-height: 1.28;\n    font-weight: 600;\n    letter-spacing: -0.015em;\n}\n\n@mixin body-text {\n    font-size: 16px;\n    line-height: 1.65;\n    font-weight: 400;\n}\n\n@mixin small-text {\n    font-size: 14px;\n    line-height: 1.5;\n    font-weight: 400;\n}\n\n\n:root {\n    --bw-text: #{$text-main};\n    --bw-text-secondary: #{$text-secondary};\n    --bw-text-tertiary: #{$text-tertiary};\n    --bw-primary: #{$color-primary};\n\n    --base-container: #{$base-container};\n    --gutter-desktop: #{$gutter-desktop};\n    --gutter-tablet: #{$gutter-tablet};\n    --gutter-mobile: #{$gutter-mobile};\n\n\n    --border-soft: #{$border-soft};\n    --border-mid: #{$border-mid};\n\n    --radius-card: #{$radius-card};\n    --radius-card-sm: #{$radius-card-sm};\n    --radius-button: #{$radius-button};\n    --radius-button-header: #{$radius-button-header};\n\n    --shadow-soft: #{$shadow-soft};\n\n}\n\n//Notes\n//El color oficial de card queda formalizado como --bw-card-surface con valor #F7F5F1. \n//Su variante complementaria --bw-card-surface-soft usa #F8F6F2 para superficies internas, previews y contenedores suaves.","@import '../../assets/styles/variables';\n\n$bw-bg: $color-bg;\n$bw-surface: $sidebar-submenu-bg;\n$bw-border: $color-border;\n$bw-primary: $color-primary;\n$bw-gold: $color-gold;\n$bw-shadow:$shadow-card;\n$bw-surface-2: $color-surface;\n$bw-text: $text-main;\n$bw-muted: $text-secondary;\n$bw-radius-xl: 24px;\n\n$white: #ffffff;\n$text-dark: $bw-text;\n$text-muted: $bw-muted;\n$accent-green: #2ecc71;\n$accent-blue: $bw-primary;\n$accent-grey: #95a5a6;\n$border-radius: 12px;\n$shadow-sm: 0 3px 7px 0px rgb(0 0 0 / 10%);\n$shadow-md: 0 4px 12px rgb(0 0 0 / 22%);\n\n.dashboard {\n  width: 100%;\n  color: $bw-text;\n  font-family: \"Sora\", sans-serif;\n  background-color: transparent;\n\n  @media (max-width: 768px) {\n    padding: 10px 0;\n  }\n\n  &__header {\n    margin-bottom: 24px;\n    padding: 0 4px;\n  }\n\n  &__title {\n    font-size: 28px;\n    font-weight: 800;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    color: $bw-text;\n    letter-spacing: -0.02em;\n\n    // svg {\n    //   font-size: 32px;\n    //   color: $bw-primary;\n    //   @media (max-width: 768px) {\n    //     font-size: 26px;\n    //   }\n    // }\n  }\n\n  &__subtitle {\n    color: $bw-muted;\n    margin: 8px 0 0;\n    font-size: 16px;\n    font-weight: 500;\n    @media (max-width: 768px) {\n      font-size: 14px;\n    }\n  }\n\n  &__mainGrid {\n    display: grid;\n    grid-template-columns: 1fr;\n    gap: 24px;\n    margin-top: 24px;\n\n    @media (min-width: 1024px) {\n      grid-template-columns: 1.8fr 1fr;\n    }\n  }\n\n  &__sidebar {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n  }\n}\n\n.widget-card {\n  background: $color-surface;\n  border: 1px solid $bw-border;\n  border-radius: $bw-radius-xl;\n  padding: 32px;\n  box-shadow: $bw-shadow;\n  display: flex;\n  flex-direction: column;\n  transition: transform 0.2s ease;\n\n  @media (max-width: 768px) {\n    padding: 24px 20px;\n  }\n\n  &:hover {\n    transform: translateY(-2px);\n  }\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 24px;\n  }\n\n  &__icon-box {\n    width: 48px;\n    height: 48px;\n    background: $bw-surface-2;\n    border: 1px solid $bw-border;\n    border-radius: 14px;\n    display: grid;\n    place-items: center;\n    color: $bw-muted;\n    flex-shrink: 0;\n\n    @media (max-width: 480px) {\n      width: 40px;\n      height: 40px;\n      border-radius: 10px;\n      svg { font-size: 20px !important; }\n    }\n  }\n\n  &__eyebrow {\n    display: block;\n    font-size: 10px;\n    font-weight: 800;\n    text-transform: uppercase;\n    letter-spacing: 0.12em;\n    color: $bw-primary;\n    margin-bottom: 2px;\n  }\n\n  &__title {\n    margin: 0;\n    font-size: 16px;\n    font-weight: 800;\n    color: $bw-text;\n    letter-spacing: -0.01em;\n  }\n}\n\n.agenda-list {\n  display: flex;\n  flex-direction: column;\n\n  &--empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 40px;\n    background: rgba($bw-primary, 0.03);\n    border-radius: 24px;\n    border: 2px dashed rgba($bw-primary, 0.15);\n    text-align: center;\n    margin: 10px 0;\n    transition: all 0.3s ease;\n\n    &:hover {\n      background: rgba($bw-primary, 0.05);\n      border-color: rgba($bw-primary, 0.25);\n    }\n\n    &__icon-box {\n      width: 64px;\n      height: 64px;\n      background: #fff;\n      border-radius: 50%;\n      display: grid;\n      place-items: center;\n      color: rgba($bw-primary, 0.4);\n      margin-bottom: 20px;\n      box-shadow: 0 10px 25px rgba(0,0,0,0.05);\n    }\n\n    &__title {\n      font-size: 18px;\n      font-weight: 800;\n      color: $bw-text;\n      margin: 0 0 8px;\n      letter-spacing: -0.02em;\n    }\n\n    &__text {\n      font-size: 14px;\n      color: $bw-muted;\n      margin: 0;\n      max-width: 280px;\n      line-height: 1.5;\n    }\n  }\n}\n\n.appointment-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 16px 20px;\n  background: $bw-surface-2;\n  border-radius: 18px;\n  margin-bottom: 12px;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n\n  @media (max-width: 600px) {\n    gap: 12px;\n    padding: 14px 16px;\n  }\n\n  &:hover {\n    background: #fff;\n    border-color: rgba($bw-primary, 0.3);\n    box-shadow: 0 8px 20px rgba(0,0,0,0.04);\n  }\n\n  &__time-box {\n    text-align: center;\n    min-width: 70px;\n    padding-right: 16px;\n    border-right: 1px solid rgba(16, 25, 21, 0.06);\n\n    @media (max-width: 480px) {\n      min-width: 60px;\n      padding-right: 10px;\n    }\n  }\n\n  &__date { \n    font-size: 11px; \n    font-weight: 800; \n    color: $bw-primary; \n    display: block; \n    text-transform: uppercase; \n    @media (max-width: 480px) { font-size: 9px; }\n  }\n  &__hour { \n    font-size: 15px; \n    font-weight: 800; \n    color: $bw-text; \n    @media (max-width: 480px) { font-size: 13px; }\n  }\n\n  &__info { flex: 1; }\n  &__professional, &__patient { \n    margin: 0; \n    font-size: 15px; \n    font-weight: 700; \n    color: $bw-text; \n    @media (max-width: 480px) { font-size: 14px; }\n  }\n  &__reason { \n    margin: 2px 0 0; \n    font-size: 13px; \n    color: $bw-muted; \n    font-weight: 500; \n    @media (max-width: 480px) { font-size: 12px; }\n  }\n\n  &__link {\n    width: 36px;\n    height: 36px;\n    background: #fff;\n    border: 1px solid $bw-border;\n    border-radius: 10px;\n    display: grid;\n    place-items: center;\n    color: $bw-primary;\n    transition: all 0.2s;\n\n    &:hover {\n        background: $bw-primary;\n        color: #fff;\n        transform: scale(1.05);\n    }\n  }\n}\n\n.kpiCard {\n  background: $color-surface;\n  border: 1px solid $bw-border;\n  border-radius: $border-radius;\n  padding: 1.5rem;\n  box-shadow: $shadow-sm;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  border-left: 5px solid transparent;\n  transition: transform 0.2s;\n\n  @media (max-width: 480px) {\n    padding: 1rem;\n    gap: 0.75rem;\n  }\n\n  &:hover {\n    transform: translateY(-3px);\n    box-shadow: $shadow-md;\n  }\n\n  &--green {\n    border-left-color: $accent-green;\n    color: darken($accent-green, 10%);\n  }\n  &--grey {\n    border-left-color: $accent-grey;\n    color: darken($accent-grey, 10%);\n  }\n\n  &__iconContainer {\n    background-color: rgba(0, 0, 0, 0.03);\n    padding: 10px;\n    border-radius: 50%;\n    display: flex;\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__label {\n    font-size: 0.8rem;\n    font-weight: 600;\n    text-transform: uppercase;\n    color: $text-muted;\n    margin-bottom: 4px;\n  }\n\n  &__value {\n    font-size: 1.5rem;\n    font-weight: 800;\n    margin: 0;\n    color: $text-dark;\n  }\n\n  &__subtext {\n    font-size: 0.85rem;\n    color: $text-muted;\n    margin-top: 4px;\n  }\n\n  &__trend {\n    font-size: 0.85rem;\n    margin-top: 4px;\n    font-weight: 600;\n\n    &--positive {\n      color: $accent-green;\n    }\n  }\n}\n\n.widget {\n  background: $white;\n  border-radius: $border-radius;\n  padding: 1.5rem;\n  box-shadow: $shadow-sm;\n  display: flex;\n  flex-direction: column;\n\n  &__header {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    margin-bottom: 1.5rem;\n    border-bottom: 1px solid lighten($text-muted, 40%);\n    padding-bottom: 1rem;\n  }\n\n  &__icon {\n    color: $text-muted;\n  }\n\n  &__title {\n    font-size: 1rem;\n    font-weight: 700;\n    margin: 0;\n    color: $text-dark;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n}\n\n.agendaWidget {\n  height: 100%;\n\n  &__list {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n  }\n}\n\n.appointmentRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1rem;\n  background-color: #f8f9fa;\n  border-radius: 8px;\n  flex-wrap: wrap;\n  gap: 1rem;\n\n  &__time {\n    display: flex;       \n    flex-direction: column; \n    align-items: center;    \n    justify-content: center;\n    min-width: 80px;\n    padding-right: 1rem;\n    border-right: 1px solid #e0e0e0; \n    margin-right: 0.5rem;\n  }\n\n  &__date {\n    font-size: 0.75rem;\n    font-weight: 700;\n    color: $text-muted;\n    text-transform: uppercase;\n    margin-bottom: 2px;\n  }\n\n  &__hour {\n    font-weight: 800;\n    color: $text-dark;\n    font-size: 1rem;\n  }\n\n  &__info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__name {\n    font-weight: 600;\n    font-size: 1rem;\n  }\n\n  &__type {\n    font-size: 0.85rem;\n    color: $text-muted;\n  }\n\n  &__action {\n    display: flex;\n  }\n}\n\n.btn {\n  border: none;\n  border-radius: 6px;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  transition: all 0.2s;\n\n  &--video {\n    background-color: $accent-blue;\n    color: $white;\n    box-shadow: 0 2px 4px rgba($accent-blue, 0.3);\n\n    &:hover {\n      background-color: darken($accent-blue, 10%);\n    }\n  }\n\n  &--outline {\n    background-color: transparent;\n    border: 1px solid $text-muted;\n    color: $text-muted;\n\n    &:hover {\n      border-color: $text-dark;\n      color: $text-dark;\n    }\n  }\n}\n\n.occupancyWidget {\n  &__content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1.5rem;\n  }\n\n  &__legend {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    width: 100%;\n\n    li {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 0.5rem;\n      font-size: 0.9rem;\n      color: $text-muted;\n    }\n  }\n}\n\n.donutChart {\n  width: 140px;\n  height: 140px;\n  border-radius: 50%;\n  background: conic-gradient($accent-green 0% 75%, lighten($text-muted, 40%) 75% 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n\n  &__center {\n    width: 100px;\n    height: 100px;\n    background: $white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 800;\n    font-size: 1.5rem;\n    color: $text-dark;\n    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.dot {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: inline-block;\n  margin-right: 8px;\n\n  &--occupied {\n    background-color: $accent-green;\n  }\n  &--free {\n    background-color: lighten($text-muted, 40%);\n  }\n}\n\n.walletWidget {\n  background: linear-gradient(135deg, $text-dark 0%, #1a252f 100%);\n  color: $white;\n\n  .widget__title,\n  .widget__icon {\n    color: $white;\n  }\n\n  .widget__header {\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n  }\n\n  &__content {\n    display: flex;\n    flex-direction: column;\n  }\n\n  &__label {\n    font-size: 0.9rem;\n    opacity: 0.7;\n    margin-bottom: 0.5rem;\n  }\n\n  &__balance {\n    font-size: 2rem;\n    margin: 0 0 1.5rem 0;\n    font-weight: 700;\n  }\n\n  &__link {\n    background: rgba(255, 255, 255, 0.1);\n    border: none;\n    color: $white;\n    padding: 0.8rem;\n    border-radius: 6px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n    font-size: 0.9rem;\n    transition: background 0.2s;\n\n    &:hover {\n      background: rgba(255, 255, 255, 0.2);\n    }\n  }\n}\n\n.patient-to-pro-banner {\n    display: flex;\n    justify-content: flex-end;\n    margin-bottom: 24px;\n}\n\n.patient-to-pro-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    background-color: #f1f5f9;\n    color: #475569;\n    padding: 8px 16px;\n    border-radius: 8px;\n    font-weight: 600;\n    font-size: 14px;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    border: 1px solid #e2e8f0;\n\n    &:hover {\n        background-color: #e2e8f0;\n        color: #0f172a;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `DashboardPatient_dashboard__w-By0`,
	"dashboard__header": `DashboardPatient_dashboard__header__-wP+9`,
	"dashboard__title": `DashboardPatient_dashboard__title__BRFVz`,
	"dashboard__subtitle": `DashboardPatient_dashboard__subtitle__wQoO-`,
	"dashboard__mainGrid": `DashboardPatient_dashboard__mainGrid__r5DF8`,
	"dashboard__sidebar": `DashboardPatient_dashboard__sidebar__ysPdw`,
	"widget-card": `DashboardPatient_widget-card__YPY+r`,
	"widget-card__header": `DashboardPatient_widget-card__header__r3WXv`,
	"widget-card__icon-box": `DashboardPatient_widget-card__icon-box__xUu9d`,
	"widget-card__eyebrow": `DashboardPatient_widget-card__eyebrow__jn5D3`,
	"widget-card__title": `DashboardPatient_widget-card__title__oxTI2`,
	"agenda-list": `DashboardPatient_agenda-list__m9KOq`,
	"agenda-list--empty": `DashboardPatient_agenda-list--empty__K5KKZ`,
	"agenda-list--empty__icon-box": `DashboardPatient_agenda-list--empty__icon-box__w77be`,
	"agenda-list--empty__title": `DashboardPatient_agenda-list--empty__title__B8r87`,
	"agenda-list--empty__text": `DashboardPatient_agenda-list--empty__text__zY0+0`,
	"appointment-item": `DashboardPatient_appointment-item__NwXdb`,
	"appointment-item__time-box": `DashboardPatient_appointment-item__time-box__kk4aR`,
	"appointment-item__date": `DashboardPatient_appointment-item__date__iV1CC`,
	"appointment-item__hour": `DashboardPatient_appointment-item__hour__jvA-3`,
	"appointment-item__info": `DashboardPatient_appointment-item__info__ER1+E`,
	"appointment-item__professional": `DashboardPatient_appointment-item__professional__gQ61-`,
	"appointment-item__patient": `DashboardPatient_appointment-item__patient__BBjaZ`,
	"appointment-item__reason": `DashboardPatient_appointment-item__reason__p02bE`,
	"appointment-item__link": `DashboardPatient_appointment-item__link__lqEvU`,
	"kpiCard": `DashboardPatient_kpiCard__3Ao4f`,
	"kpiCard--green": `DashboardPatient_kpiCard--green__7etih`,
	"kpiCard--grey": `DashboardPatient_kpiCard--grey__xUbMi`,
	"kpiCard__iconContainer": `DashboardPatient_kpiCard__iconContainer__PmqQA`,
	"kpiCard__content": `DashboardPatient_kpiCard__content__kOfKW`,
	"kpiCard__label": `DashboardPatient_kpiCard__label__ITu-y`,
	"kpiCard__value": `DashboardPatient_kpiCard__value__TNV76`,
	"kpiCard__subtext": `DashboardPatient_kpiCard__subtext__nG5eN`,
	"kpiCard__trend": `DashboardPatient_kpiCard__trend__--0Nm`,
	"kpiCard__trend--positive": `DashboardPatient_kpiCard__trend--positive__lp83l`,
	"widget": `DashboardPatient_widget__jA0i0`,
	"widget__header": `DashboardPatient_widget__header__pWXaH`,
	"widget__icon": `DashboardPatient_widget__icon__H4Qem`,
	"widget__title": `DashboardPatient_widget__title__jqFB6`,
	"agendaWidget": `DashboardPatient_agendaWidget__qYQrq`,
	"agendaWidget__list": `DashboardPatient_agendaWidget__list__MGNro`,
	"appointmentRow": `DashboardPatient_appointmentRow__gdUZB`,
	"appointmentRow__time": `DashboardPatient_appointmentRow__time__0LF6j`,
	"appointmentRow__date": `DashboardPatient_appointmentRow__date__SAIzq`,
	"appointmentRow__hour": `DashboardPatient_appointmentRow__hour__0B0bD`,
	"appointmentRow__info": `DashboardPatient_appointmentRow__info__plDKm`,
	"appointmentRow__name": `DashboardPatient_appointmentRow__name__wKNc9`,
	"appointmentRow__type": `DashboardPatient_appointmentRow__type__dpEqK`,
	"appointmentRow__action": `DashboardPatient_appointmentRow__action__V7e7x`,
	"btn": `DashboardPatient_btn__QfZ38`,
	"btn--video": `DashboardPatient_btn--video__ptvi7`,
	"btn--outline": `DashboardPatient_btn--outline__XS6ob`,
	"occupancyWidget__content": `DashboardPatient_occupancyWidget__content__1MZGE`,
	"occupancyWidget__legend": `DashboardPatient_occupancyWidget__legend__NvmMD`,
	"donutChart": `DashboardPatient_donutChart__tS9HH`,
	"donutChart__center": `DashboardPatient_donutChart__center__zPnwm`,
	"dot": `DashboardPatient_dot__HulH3`,
	"dot--occupied": `DashboardPatient_dot--occupied__9f10r`,
	"dot--free": `DashboardPatient_dot--free__jStKk`,
	"walletWidget": `DashboardPatient_walletWidget__YpJiy`,
	"walletWidget__content": `DashboardPatient_walletWidget__content__WiX2D`,
	"walletWidget__label": `DashboardPatient_walletWidget__label__ccSrR`,
	"walletWidget__balance": `DashboardPatient_walletWidget__balance__P+Y4-`,
	"walletWidget__link": `DashboardPatient_walletWidget__link__nXZS8`,
	"patient-to-pro-banner": `DashboardPatient_patient-to-pro-banner__LImKz`,
	"patient-to-pro-btn": `DashboardPatient_patient-to-pro-btn__Nf1Ba`
};
export default ___CSS_LOADER_EXPORT___;
